import { difference, map } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    addVedtakskodeIleggelseType,
    deleteVedtakskodeIleggelseType,
    getVedtakskoder,
    putVedtakskoder,
} from "../../../../actions/vedtakskoderAction";
import {
    IsValidated,
    onChangeValidation,
} from "../../../../utils/validationUtils";
import ModalGeneric from "../../../Common/ModalGeneric";
import UpdateOpenModal from "../../CreateModals/UpdateOpenModal";
import VedtakskoderForm from "../../VedtakskoderForm";

const rules = {
  id: "required;isDigit",
  kode: "required;minLength=2;maxLength=50",
  navn: "required;minLength=2;maxLength=50",
  klageKodeId: "required",
  ileggelsestype: "required",
  deaktivertDato: "required;isDato",
};

function stateFromProps(vedtakskode, selectedIleggelsestyper) {
  return {
    open: false,
    submitButtonText: "Lagre",
    id: vedtakskode.id,
    kode: vedtakskode.kode,
    navn: vedtakskode.navn,
    medhold: "",
    deaktivertDato: vedtakskode.deaktivertDato ? vedtakskode.deaktivertDato : "",
    tilkemner: vedtakskode.tilkemner ? vedtakskode.tilkemner : false,
    selectedIleggelsestyper: selectedIleggelsestyper,
    modifiedIleggelsestyper: selectedIleggelsestyper,
    klageKodeId: vedtakskode.klagekode ? vedtakskode.klagekode.id : 0,
    validationError: {},
    openDeaktiverConfirm: false,
  };
}

function VedtakskodeModal({ vedtakskode, selectedIleggelsestyper }) {
  const dispatch = useDispatch();
  const ileggelsestyper = useSelector((state) => state.ileggelsestyper);
  const klagekoder = useSelector((state) => state.klagekoder);

  const [state, setState] = useState(() => stateFromProps(vedtakskode, selectedIleggelsestyper));
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  useEffect(() => {
    if (vedtakskode) {
      setState((s) => ({
        ...stateFromProps(vedtakskode, selectedIleggelsestyper),
        open: s.open,
      }));
    }
  }, [vedtakskode, selectedIleggelsestyper]);

  const closeModal = () => setState(stateFromProps(vedtakskode, selectedIleggelsestyper));
  const openModal = () => update({ open: true });

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const updateVedtakskodeIleggelsetyper = async () => {
    const IleggelsestypeIdsToAdd = difference(
      state.modifiedIleggelsestyper,
      state.selectedIleggelsestyper
    );
    const IleggelsestypeIdsToDelete = difference(
      state.selectedIleggelsestyper,
      state.modifiedIleggelsestyper
    );
    if (IleggelsestypeIdsToAdd.length > 0) {
      await Promise.all(
        map(IleggelsestypeIdsToAdd, (id) =>
          dispatch(addVedtakskodeIleggelseType(vedtakskode.id, id))
        )
      );
    }
    if (IleggelsestypeIdsToDelete.length > 0) {
      await Promise.all(
        map(IleggelsestypeIdsToDelete, (id) =>
          dispatch(deleteVedtakskodeIleggelseType(vedtakskode.id, id))
        )
      );
    }
  };

  const handlePut = async () => {
    update({ submitButtonText: "Lagrer..." });
    const payload = {
      kode: state.kode,
      navn: state.navn,
      deaktivertDato: state.deaktivertDato || null,
      klageKodeId: state.klageKodeId && Number(state.klageKodeId),
    };
    await dispatch(putVedtakskoder(state.id, payload));
    await updateVedtakskodeIleggelsetyper();
    await dispatch(getVedtakskoder());
    closeModal();
  };

  const saveAndClose = async () => {
    if (isValid() && !state.deaktivertDato) {
      await handlePut();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const patch = name === "ileggelsestype"
      ? { modifiedIleggelsestyper: value, [name]: value }
      : { [name]: value };
    const draft = { ...state, ...patch };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <>
      <ModalGeneric
        modalTitle="Rediger vedtakskode"
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={UpdateOpenModal}
        submit={saveAndClose}
        submitButtonText={state.submitButtonText}
      >
        <VedtakskoderForm
          id={state.id}
          kode={state.kode}
          navn={state.navn}
          tilkemner={state.tilkemner}
          klageKodeId={state.klageKodeId}
          deaktivertDato={state.deaktivertDato}
          klagekoder={klagekoder}
          ileggelsestyper={ileggelsestyper}
          ileggelsestype={state.modifiedIleggelsestyper}
          handleChange={handleChange}
          validationError={state.validationError}
          actionType="update"
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver vedtakskode"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={handlePut}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere vedtakskode {state.id}?</p>
      </ModalGeneric>
    </>
  );
}

export default VedtakskodeModal;
